import { SessionUid } from "./base";
import { PollConfig, isDiscretePollConfig, normalizeDiscreteOptions } from "./poll.types";

export type ItemData = SessionUid & {
  categoryUid: string;
  supporterUids: Map<string, boolean>; // user uid : member (always true)
  ownerUid: string;
  createdDate: Date;
  text: string;
  pollResponses: Map<string, string>; // user uid : option text
  editingBy: { uid: string; timestamp: number } | null;
  pinned: boolean;
  pollUid?: string;
  pollConfig?: PollConfig;
  flipText?: string;
  backgroundImageUrl?: string;
  visible?: boolean;
  // Derived (non-persisted): set when text or pollConfig were encrypted but no available key decrypted them
  undecrypted?: boolean;
}

export type SerializedItemData = SessionUid & {
  categoryUid: string;
  supporterUids: Record<string, boolean>;
  ownerUid: string;
  createdDate: number;
  text: string;
  pollResponses: Record<string, string>;
  editingBy: { uid: string; timestamp: number } | null;
  pinned: boolean;
  pollUid?: string;
  pollConfig?: PollConfig;
  flipText?: string;
  backgroundImageUrl?: string;
  visible?: boolean;
}

export function serializeItem(i: ItemData): SerializedItemData {
  return {
    ...i,
    createdDate: i.createdDate.getTime(),
    supporterUids: Object.fromEntries(i.supporterUids),
    pollResponses: Object.fromEntries(i.pollResponses),
  };
}

export function itemTransform(val: Record<string, unknown> | null): ItemData {
  // react-firebase-hooks calls transforms with `null` when the snapshot has no data.
  if (val == null) return val as unknown as ItemData;
  const pollConfig = val.pollConfig as PollConfig | undefined;
  const normalizedPollConfig = pollConfig && isDiscretePollConfig(pollConfig)
    ? { ...pollConfig, options: normalizeDiscreteOptions(pollConfig.options as any) }
    : pollConfig;
  return {
    ...val,
    createdDate: new Date(val.createdDate as number),
    supporterUids: new Map(Object.entries(val.supporterUids as Record<string, boolean> || {})),
    pollResponses: new Map(Object.entries(val.pollResponses as Record<string, string> || {})),
    editingBy: (val.editingBy as { uid: string; timestamp: number }) ?? null,
    pinned: !!val.pinned,
    ...(normalizedPollConfig && { pollConfig: normalizedPollConfig }),
  } as ItemData;
}
